import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'

import requests from 'app/requests/OpportunityForecast.requests'
import {
    ForecastData,
} from '../../../Forecast.types'

const useGetAccount = (id) => {
    const {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
        invalidate,
    } = useRequest<ForecastData>({
        key: RequestKeys.getCurrentMonthForecast,
        params: {
            id,
        },
        requestFunc: RequestFn.getEntity(requests.getCurrentMonth),
        enabled: Boolean(id),
    })

    return {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
        invalidate,
    }
}

export default useGetAccount
